import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import VerifyOTPPayrollModal from '../VerifyOTPPayrollModal/VerifyOTPPayrollModal';
import ManageRequest from '../../pages/ManageRequest';
import { Spin } from 'antd';

interface ParamTypes {
  id: string;
}

const ProtectedPayrollDetail: React.FC = () => {
  const { id } = useParams<ParamTypes>();
  const location = useLocation();
  const history = useHistory();
  const [showOTP, setShowOTP] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get the full URL search params
    const searchParams = new URLSearchParams(window.location.search);
    const fromEmail = searchParams.get('fromEmail') === 'true';

    // If coming from email link, clear any existing OTP verification
    if (fromEmail) {
      localStorage.removeItem('isVerifyOTP');
      localStorage.setItem('fromEmail', 'true');

      // Clean up the URL by removing the fromEmail parameter
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete('fromEmail');

      const newUrl = newSearchParams.toString()
        ? `${window.location.pathname}?${newSearchParams.toString()}`
        : window.location.pathname;

      window.history.replaceState({}, '', newUrl);
      setShowOTP(true);
    } else {
      // Check if we need to show OTP from localStorage
      const needsOTP = localStorage.getItem('fromEmail') === 'true';
      setShowOTP(needsOTP);
    }

    setLoading(false);
  }, [id]);

  const handleVerifyOTP = (isVerify: boolean) => {
    if (isVerify) {
      // Clear the flag from localStorage on successful verification
      localStorage.removeItem('fromEmail');
      setShowOTP(false);
    } else {
      // If verification fails, redirect to payroll list
      history.push('/payroll/pay-runs');
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  const handleCloseOTP = () => {
    setShowOTP(false);
  };

  return (
    <>
      <VerifyOTPPayrollModal
        open={showOTP}
        onClose={handleCloseOTP}
        type="payroll"
        handleVerifyOTP={handleVerifyOTP}
        title="Please verify OTP to view payroll details"
      />
      {!showOTP && <ManageRequest />}
    </>
  );
};

export default ProtectedPayrollDetail;
